import BackendClient from '../backend-client';
import AppPromo, { modelFactory } from './model';

export default class AppPromoClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
    // this.$path = `/login/${ modelFactory.ns}`;
  }

  getMenssagePopup = async (filters) => {
    try {
      const where = ['ACTIVE_STATE = 0'];

      if (typeof filters.primaryIndex === 'number') {
        where.push(`PRIMARY_INDEX=${filters.primaryIndex}`);
      }

      if (typeof filters.status === 'string') {
        where.push(`STATUS_ID in ${filters.status}`);
      }

      if (typeof filters.id === 'number') {
        where.push(`ID != ${filters.id}`);
      }

      const response = await this.request('get')(
        {
          filter: where.join(' AND '),
        },
        { path: 'login/popup' },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }

  getMenssagePopupOfferApp = async () => {
    try {
      const where = [`ID = ${process.env.VUE_APP_KI_POPUP_LOGIN_OFFER_APP}`];// 450288

      const response = await this.request('get')(
        {
          filter: where.join(' AND '),
        },
        { path: 'login/popup/offerapp' },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }

  getTour = async (filters) => {
    // localStorage.removeItem('tourSteps');
    // localStorage.removeItem('tourStepsIndex');

    try {
      const where = ['ACTIVE_STATE = 0'];

      if (typeof filters.primaryIndex === 'number') {
        where.push(`PRIMARY_INDEX=${filters.primaryIndex}`);
      }

      if (typeof filters.status === 'string') {
        where.push(`STATUS_ID in ${filters.status}`);
      }

      if (typeof filters.id === 'number') {
        where.push(`ID = ${filters.id}`);
      }

      const response = await this.request('get')(
        {
          filter: where.join(' AND '),
        },
        { path: 'login/popup' },
      );

      // console.log('Tour data fetched from API:', response);
      // localStorage.setItem('tour',
      // JSON.stringify(response.data.collection_message.message[0].resolutions));
      // console.log('Tour data to be stored in localStorage:',
      // response.data.collection_message.message[0].resolution);
      // console.log('TOUR_HOME_STEPS_MOCK', TOUR_HOME_STEPS_MOCK);
      // console.log('TOUR_HOME_STEPS_MOCK', JSON.stringify(TOUR_HOME_STEPS_MOCK));
      // localStorage.setItem('tourSteps', JSON.stringify(TOUR_HOME_STEPS_MOCK));
      localStorage.setItem('tourSteps', response.data.collection_message.message[0].resolution);
      localStorage.setItem('tourStepsIndex', '0');
      // console.log('tour', TOUR_HOME_STEPS_MOCK);
      console.log('responsedata', response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }
}

export {
  AppPromo,
};
